import { gql } from '@apollo/client';

const AI_GET_PROMPT_REPORT_QUERY = gql`
    query GetPromptReport( $promptId: UUID!, $reportId: UUID! ) {
        promptReport( promptId:$promptId, reportId: $reportId ) {
            id
            companyId
            promptId
            csvObjectKey
            graphObjectKey
            rawData
            numRows
            createdAt
            updatedAt
            graphSignedUrl
            csvSignedUrl
    }
    }
`;

export default AI_GET_PROMPT_REPORT_QUERY;
